// extracted by mini-css-extract-plugin
export var dropdownButton = "_47-0";
export var fullWidthDropdownButton = "_47-1";
export var icon = "_47-3";
export var iconPlaceholder = "_47-2";
export var menuItemRow = "_47-8";
export var separator = "_47-d";
export var shortcutContainer = "_47-7";
export var shortcutIconLg = "_47-6";
export var shortcutIconMd = "_47-5";
export var shortcutIconSm = "_47-4";
export var submenuChevron = "_47-c";
export var submenuDropdown = "_47-9";
export var submenuTriggerRow = "_47-a";
export var submenuTriggerRowOpen = "_47-b";